<script lang="ts">
	import { getFormattedDate } from '@astlai/common/util';
	import type { CitedSource, DocumentOverview, WebSourceDocument } from 'src/types/llm';
	import { t } from './i18n/tranlsator.svelte';

	interface Props {
		doc: DocumentOverview | WebSourceDocument | CitedSource;
	}
	let { doc }: Props = $props();

	function getSubtitle(type: string) {
		const key = `docType.${type}` as Parameters<typeof t>[0];
		const translated = t(key);
		return translated === key ? type : translated;
	}

	function getHostname(url: string) {
		try {
			return new URL(url).hostname;
		} catch {
			return url;
		}
	}

	const isWebSource = $derived('url' in doc); // TODO might be a too weak check, rather check for type
	const published_date = $derived(
		!isWebSource
			? (doc as DocumentOverview).doc_date ||
				(doc as DocumentOverview).res_date ||
				(doc as DocumentOverview).meta?.speech_date
			: undefined
	);
</script>

<div class="info">
	{#if isWebSource}
		{@const web = doc as WebSourceDocument}
		<span class="title">{web.title}</span>
		<span class="subtitle">{getHostname(web.url)}</span>
	{:else}
		{@const d = doc as DocumentOverview}
		<span class="title">
			{#if d.type === 'speech'}Rede von {d.meta?.speaker}
			{:else if d.type === 'eu_com_proposal'}Commission Proposal {d.meta?.com_id}
			{:else if d.type === 'cla_paragraph'}{d.meta?.section_id} {d.res_name}
			{:else}
				{d.res_name}
			{/if}
		</span>
		{#if d.type === 'cla_paragraph' || d.type === 'cla_annex'}
			<span class="subtitle">{d.res_name}</span>
		{:else}
			<span class="subtitle">
				{published_date ? getFormattedDate(published_date) + ' | ' : ''}{getSubtitle(
					d.type
				)}{d.type === 'kleine_anfrage' ? ` | ${d.meta.urheber}` : ''}
			</span>
		{/if}
	{/if}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;
	.info {
		flex: 1 1 auto;
		@include lib.flex-column();
		@include lib.flex-align(center, stretch);
		overflow: hidden;
		text-align: left;
		.title {
			@include lib.ellipsis();
		}
		.subtitle {
			@include lib.ellipsis();
			font-size: 0.75rem;
			color: var(--text-secondary);
		}
	}
</style>
